import emailjs from "@emailjs/browser";
import { useState } from "react";
import { toast } from "react-toastify";

const Contact = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    subject: "",
    message: "",
  });
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    try {
      // Replace the following with deva EmailJS service ID, template ID, and public key
      const serviceID = "service_qvf42xf";
      const templateID = "template_vs5gjlw";
      const publicKey = "vldDBtIslSk-M3ioj";

      await emailjs.send(serviceID, templateID, formData, publicKey);

      setFormData({
        name: "",
        email: "",
        subject: "",
        message: "",
      });

      toast.success("Message sent successfully!");
    } catch (error) {
      toast.error("Failed to send message. Please try again.");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="w-[100%] md:w-[90%] px-8 m-auto ">
      <div className="min-h-screen bg-white p-4 md:p-8 flex justify-center">
        <div className="mx-auto">
          <div className="border-2 w-full border-[#293855] rounded-lg p-6">
            <div className="mb-8">
              <h2 className="text-2xl font-bold text-center text-[#F1AC20] mb-4">GET IN TOUCH</h2>
              <div className="flex flex-col items-center -mt-2 mb-5">
                <div className="border-b-4 w-[70px] border-[#293855] rounded-2xl"></div>
              </div>
              <div className="px-5">
                <p className="text-center text-[#454444] text-[14px] text-sm md:text-base">
                  Interested in working together? Fill out the form below with some information about your project, and
                  I will get back to you as soon as I can. Please allow a couple of days for me to respond.
                </p>
              </div>
            </div>

            <form onSubmit={handleSubmit} className="space-y-6 px-5">
              <div>
                <input
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  placeholder="Your Name"
                  required
                  className="w-full px-4 py-3 rounded-xl bg-gray-50 border border-gray-200 
                     focus:outline-none focus:ring-2 focus:ring-orange-200 focus:border-orange-400
                     transition-all duration-200 placeholder:text-[#2A2A2A] placeholder:text-[14px] placeholder:font-semibold"
                />
              </div>

              <div>
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  placeholder="Your Email"
                  required
                  className="w-full px-4 py-3 rounded-xl bg-gray-50 border border-gray-200 
                     focus:outline-none focus:ring-2 focus:ring-orange-200 focus:border-orange-400
                     transition-all duration-200 placeholder:text-[#2A2A2A] placeholder:text-[14px] placeholder:font-semibold"
                />
              </div>

              <div>
                <input
                  type="text"
                  name="subject"
                  value={formData.subject}
                  onChange={handleChange}
                  placeholder="Subject"
                  required
                  className="w-full px-4 py-3 rounded-xl bg-gray-50 border border-gray-200 
                     focus:outline-none focus:ring-2 focus:ring-orange-200 focus:border-orange-400
                     transition-all duration-200 placeholder:text-[#2A2A2A] placeholder:text-[14px] placeholder:font-semibold"
                />
              </div>

              <div>
                <textarea
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  placeholder="Message"
                  required
                  rows={5}
                  className="w-full px-4 py-3 rounded-xl bg-gray-50 border border-gray-200 
                     focus:outline-none focus:ring-2 focus:ring-orange-200 focus:border-orange-400
                     transition-all duration-200 resize-none placeholder:text-[#2A2A2A] placeholder:text-[14px] placeholder:font-semibold"
                />
              </div>

              <div className="flex justify-end">
                <button
                  type="submit"
                  disabled={isSubmitting}
                  className="bg-[#2B3B4E] text-white font-semibold px-8 py-3 rounded-md
                     hover:bg-[#1E2A3B] transition-colors duration-200
                     disabled:opacity-70 disabled:cursor-not-allowed
                     focus:outline-none focus:ring-2 focus:ring-[#2B3B4E] focus:ring-offset-2"
                >
                  {isSubmitting ? "Sending..." : "Send Message"}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;
